import { Accordion } from '@chakra-ui/react'
import * as React from 'react'
import { LuChevronDown } from 'react-icons/lu'

import { HStack } from '@/components/ui/stack'

interface IAccordionItemTriggerProps extends Accordion.ItemTriggerProps {
    indicatorPlacement?: 'start' | 'end' | 'none'
}

export const AccordionItemTrigger = React.forwardRef<HTMLButtonElement, IAccordionItemTriggerProps>(
    function AccordionItemTrigger(props, ref) {
        const { children, indicatorPlacement = 'end', ...rest } = props
        return (
            <Accordion.ItemTrigger {...rest} ref={ref}>
                {indicatorPlacement === 'start' && (
                    <Accordion.ItemIndicator rotate={{ base: '-90deg', _open: '0deg' }}>
                        <LuChevronDown />
                    </Accordion.ItemIndicator>
                )}
                <HStack gap="4" flex="1" textAlign="start" width="full">
                    {children}
                </HStack>
                {indicatorPlacement === 'end' && (
                    <Accordion.ItemIndicator>
                        <LuChevronDown />
                    </Accordion.ItemIndicator>
                )}
            </Accordion.ItemTrigger>
        )
    },
)

// eslint-disable-next-line @typescript-eslint/naming-convention
type IAccordionItemContentProps = Accordion.ItemContentProps

export const AccordionItemContent = React.forwardRef<HTMLDivElement, IAccordionItemContentProps>(function AccordionItemContent(props, ref) {
    return (
        <Accordion.ItemContent>
            <Accordion.ItemBody ref={ref} {...props} />
        </Accordion.ItemContent>
    )
})

export const AccordionRoot = Accordion.Root
export const AccordionItem = Accordion.Item
export const AccordionItemIndicator = React.forwardRef<HTMLDivElement, React.ComponentProps<typeof Accordion.ItemIndicator>>(
    function AccordionItemIndicator(props, ref) {
        return (
            <Accordion.ItemIndicator ref={ref} {...props}>
                <LuChevronDown />
            </Accordion.ItemIndicator>
        )
    },
)
